import { render, staticRenderFns } from "./CreateClaimSelectParts.vue?vue&type=template&id=6c00c20f"
import script from "./CreateClaimSelectParts.vue?vue&type=script&lang=js"
export * from "./CreateClaimSelectParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports